import { recycleElectronicsData } from "constants-lib/seo/recycleElectronicsData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getRecycleElectronics = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Recycle Electronics JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRecycleElectronics = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/video-can-you-show-me-how-to-recycle-electronics-packaging`,
    ) &&
    document.getElementById(`recycleElectronics`) === null
  ) {
    const script = recycleElectronicsJSONLD()
    addJSONLDToHead(script, `recycleElectronics`)
  } else {
    removeElement(`recycleElectronics`)
  }
}

// JSON LD template for Recycle Electronics
const recycleElectronicsJSONLD = () => {
  const recycleElectronicsTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRecycleElectronics(recycleElectronicsData),
  }
  return recycleElectronicsTemplate
}
